// extracted by mini-css-extract-plugin
module.exports = {"StockCorporateActionsPage":"all_StockCorporateActionsPage__Em8Lp","container":"all_container__QbJws"};